import React, { useState, useEffect } from "react";
import FlyerTable from "../components/FlyerTable";
import firebase from "../util/firebase";
import { InformationCircleIcon } from "@heroicons/react/solid";
import { useAuth } from "../context/auth-context";

export default function AllFlyers() {
  const [flyers, setFlyers] = useState([]);
  const [filteredFlyers, setFilteredFlyers] = useState([]);
  const { currentUser } = useAuth();
  console.log(currentUser);

  useEffect(() => {
    const fetchFlyers = async () => {
      const snapshot = await firebase.firestore().collection("flyers").get();
      const fetchedFlyers = [];
      snapshot.forEach((doc) => {
        const flyer = doc.data();
        flyer.id = doc.id; // Make sure to include the document ID
        fetchedFlyers.push(flyer);
      });
      setFlyers(fetchedFlyers);

      // Filter flyers based on currentUser.brand.id
      const filtered = fetchedFlyers.filter(
        (flyer) =>
          flyer.allowedBrands &&
          flyer.allowedBrands.includes(currentUser.brand.id)
      );
      setFilteredFlyers(filtered);
    };

    fetchFlyers();
  }, [currentUser]);

  useEffect(() => {
    // console log flyer if 2 flyers have the same id
    let ids = [];
    const flyerIds = flyers.map((flyer) =>
      ids.includes(flyer.id) ? null : ids.push(flyer.id)
    );
  }, [flyers]);

  return (
    <div>
      <FlyerTable flyers={filteredFlyers} />
    </div>
  );
}
